module.exports = __webpack_public_path__ + "media/svg-new/ic-back-793a31ad.svg";